import React from 'react';
import ReactDOM from 'react-dom';
import { storeHistory } from '../actions/playlistActions';
import { connect } from "react-redux";
import store from 'store';
import Cookies from 'js-cookie';
import bdAuth from '../../@packages/@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '../../@packages/@bd-uikit-web/js-helpers/bdReq';
import Home from './Home';
import Freemium from './Fremium'
import { sendCanvasDetails } from './utils'

export class SplashScreen extends React.Component {

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.register = '';

    this.state = {
      token: bdAuth.getToken() ? true : false || '',
      subscription: store.get('subscription') == "no" ? false : true || ''
    }
    // store.set('featured', undefined);
  }

  componentDidMount() {
    if (!bdAuth.getToken()) {
      const thisNode = ReactDOM.findDOMNode(this);
      thisNode.querySelector('.launch-page__content-wrapper__container__btn').focus();
    }
  }

  componentWillMount() {
    const deviceName = store.get('device-name');
    const deviceId = store.get('bd-android-app__device-id') || '';
    sendCanvasDetails(deviceName, deviceId);
    const { dispatch } = this.props;
    this.props.setHistory(this.props.history);
    if (deviceId) {
      bdReq.get(`/devices/${deviceId}`)
        .then((data) => {
          this.register = data.success;
          if (data.success) {
            this.setState({ token: true });
            store.set('device-id', data.body.device.id);
            var emailId = data.body.device._embedded.user.email;
            const userId = data.body.device._embedded.user.id;
            let { artist, ...y } = data.body.device._embedded.user;
            store.set('auth__user', y);
            this.checkSubscription(userId);
            if (!bdAuth.getToken()) {
              this.fetchToken(emailId, userId);
            }
          }
        })
        .catch(err => { });
    }

    if (!bdAuth.getToken()) {
      if (store.get('auth__user')) {
        this.setState({ token: true });
        let user = store.get('auth__user') || '';
        const emailId = user.email;
        let userId = user.id ? user.id : user || '';
        this.fetchToken(emailId, userId);
      }
    }
  }

  fetchToken(emailId, userId) {
    bdReq.post('/emailLogin', { emailId })
      .then((data) => {
        if (data.success) {
          bdAuth._storeToken(data.body);
          this.checkSubscription(userId);
        }
      })
      .catch(err => { this.setState({ token: false }) });
  }

  checkSubscription(userId) {
    bdReq.get(`/users/${userId}/subscriptions`)
      .then((response) => {
        if (response.status != 200) {
          store.remove('subscription');
          store.set('subscription', "no");
          this.setState({ subscription: false })
        }
        else {
          store.remove('subscription');
          store.set('subscription', "yes");
          store.remove('description');
          store.set('description', response.body.plan.description);
          this.setState({ subscription: true })
        }
      })
      .catch(err => { });
  }

  handleClick() {
    this.props.history.push('/freemium');
  }

  render() {
    if (this.state.token) {
      return (this.state.subscription ?
        <Home /> :
        <Freemium />)
    }
    else
      return (
        <section className="launch-page">
          <video className="launch-page__video" src="https://assets.blackdove.com/videos/753585146.mp4" autoPlay loop poster="data:image/gif,AAAA"></video>
          <div className="launch-page__content-wrapper">
            <div className="launch-page__content-wrapper__container">
              <img className="launch-page__content-wrapper__container__logo" src="https://assets.blackdove.com/images/horizontal_alternate.svg" />
              <h2 className="launch-page__content-wrapper__container__title h--spacing-sm">The Art Experience</h2>
              <h5 className="launch-page__content-wrapper__container__subtitle h--normalize-weight ">
                Explore, collect and display new media artwork from<br />
                around the world.
            </h5>
              <button ref={(instance) => this.nextBtn = instance} tabIndex='1' onClick={this.handleClick} className="launch-page__content-wrapper__container__btn btn btn--round" >Experience video art</button>
            </div>
          </div>
        </section>
      )
  }
}

const mapDispatchToProps = (dispatch) => ({
  setHistory: (history) => dispatch(storeHistory(history)),
});

export default connect((state) => {
  return {
  }
}, mapDispatchToProps)(SplashScreen)